// Money + id formatters shared by the finance notification UI.
//
// `amount` from svc-finance's pg_notify trigger is a bigint serialized as
// string in **minor units** (THB → satang). The BO admin scope is single-
// currency in v1 (THB default) so we hard-format with 2dp; multi-currency
// support comes when the WS payload starts carrying `currency`.

const THB_FORMATTER = new Intl.NumberFormat('th-TH', {
  style: 'currency',
  currency: 'THB',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function formatMoneyMinor(
  amount: string | undefined,
  _currency: 'THB' = 'THB',
): string | null {
  if (!amount) return null;
  try {
    const minor = BigInt(amount);
    // BigInt divide loses fraction — go through Number once we're scaled.
    const major = Number(minor) / 100;
    if (!Number.isFinite(major)) return null;
    return THB_FORMATTER.format(major);
  } catch {
    return null;
  }
}

export function shortId(id: string | undefined): string {
  if (!id) return '';
  return id.slice(0, 8);
}
